<template>
    <div class="row">
        <div class="col-md-12">
            <div class="panel panel-primary">
                <div class="panel-heading">
                    <h3>
                        Enviar Notificação

                        <i class="fa fa-envelope right" style="margin-top:3px;"></i>
                    </h3>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-md-6">
                            <form action="">
                                <div class="form-group">
                                    <label for="type">Canal</label>
                                    <select name="type" class="form-control" v-model="notification.channel" id="type">
                                        <option value="news">Novidades</option>
                                        <option value="test_channel">Testes internos (enviada para usuários com flag Notificações de Teste = sim no cadastro)</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="title">Título da Notificação</label>
                                    <input type="text" class="form-control" id="title" v-model="notification.title">
                                </div>

                                <div class="form-group">
                                    <label for="type">Tipo</label>
                                    <select name="type" class="form-control" v-model="notification.type" id="type" @change="getRelations">
                                        <option value="none">Avulsa</option>
                                        <option value="product">Produto</option>
                                        <option value="recipe">Receita</option>
                                        <option value="link">Link</option>
                                    </select>
                                </div>

                                <div class="form-group" v-if="notification.type === 'product' || notification.type === 'recipe'">
                                    <label for="relation_id">Relação</label>
                                    <select name="relation_id" class="form-control" v-model="notification.relation_id" id="relation_id">
                                        <option value="">Selecione uma opção</option>
                                        <option v-for="rel in relations" :value="rel.id">{{ rel.name }}</option>
                                    </select>
                                </div>

                                <div class="form-group" v-if="notification.type === 'link'">
                                    <label for="title">Link Externo</label>
                                    <input type="text" class="form-control" id="title" v-model="notification.link">
                                </div>

                                <div class="form-group">
                                    <label for="body">Corpo da Notificação</label>
                                    <textarea class="form-control" rows="6" id="body" v-model="notification.body"></textarea>
                                </div>

                                <input type="radio" id="now" name="send_at" checked="checked" value="now" v-model="picked">
                                <label for="now">Enviar agora</label>
                                <br>
                                <input type="radio" id="later" name="send_at" value="later" v-model="picked">
                                <label for="later">Agendar para:</label>
                                <input type="date" name="send_at_date" id="send_at_date" v-model="send_at_date">
                                <input type="time" name="send_at_time" id="send_at_time" v-model="send_at_time">
                                <button type="button" class="btn btn-success pull-right" @click="save">Enviar Notificação <i class="fa fa-send"></i></button>
                            </form>
                        </div>
                        <div class="col-md-6">
                            <base-crud
                                ref="basecrud"
                                crudName="Notificações Agendadas"
                                newText=""
                                :table="notificationTable"
                                :columns="columns"
                                :options="options"
                                :endPoint='endPoint'
                                :enableAdd="false"
                                :enableEdit="false"
                                :enableDelete="true"
                                :enableView="false">
                            </base-crud>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data() {
    return {
      notification: {
        channel: "news",
        title: "",
        body: "",
        type: "none",
        link: "",
        relation_id: "",
        send_at: null
      },
      relation: {
        id: "",
        type: ""
      },
      relations: [],
      picked: "now",
      send_at_date: new Date().toLocaleDateString("en-CA"),
      send_at_time: new Date().toTimeString().slice(0, 5),
      notificationTable: "notificationTable",
      pages: [],
      url: "",
      columns: ["channel", "title", "body", "send_at", "actions"],
      tableData: ["channel", "title", "body", "send_at"],
      options: {
        sortable: ["channel", "title", "body", "send_at"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          channel: "Canal",
          title: "Título",
          send_at: "Programada para",
          actions: "Ações"
        }
      },
      endPoint: "notification/?showAll=true/"
    };
  },
  components: {
    BaseCrud
  },
  methods: {
    save: function() {
      const self = this;
      let api = self.$store.state.api + "notification/send";

      if (self.picked === "later") {
        api = self.$store.state.api + "notification";
        self.notification.send_at = self.send_at_date + " " + self.send_at_time;
      }

      const _channel = self.notification.channel || "news";
      const _type = self.notification.type || "none";

      self.$http
        .post(api, self.notification)
        .then(response => {
          self.$message(null, "Notificação enviada com sucesso", "success");
          const basecrud = this.$refs.basecrud;
          basecrud.refresh();
          self.notification = {
            channel: _channel,
            title: "",
            body: "",
            type: _type,
            link: "",
            relation_id: "",
            send_at: null
          };
          self.picked = "now";
        })
        .catch(error => {
          self.errors = error.response.data;

          if (typeof self.errors === "object") {
            let html = "<ul>";

            $.each(self.errors, function(key, value) {
              html += '<li class="m-t-sm m-b-sm">' + value[0] + "</li>";
            });

            html += "</ul>";

            self.errors = html;
          }

          self.$message(null, self.errors, "error");
        });
    },
    getRelations: function() {
      const self = this;

      if (self.notification.type !== "product" &&
          self.notification.type !== "recipe") {
        self.notification.relation_id = "";
        self.relations = [];
        return;
      }

      self.notification.relation_id = "";

      const api =
        self.$store.state.api + self.notification.type + "?paginated=false";

      self.$http
        .get(api)
        .then(response => {
          self.relations = response.data.data;
        })
        .catch(() => {
          self.$message(
            null,
            "Ocorreu um erro ao buscar as informações das relações",
            "error"
          );
        });
    }
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Notification/Index.vue